export default __webpack_public_path__ + "static/media/City_Scour_Logo.5966307e.png";